import { useState } from 'react'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import { brandsService } from 'services/brand.service'

import { _object } from 'utils/interfaces'

import { Button, InputField } from '../form-inputs'

const AddHomeDeal = () => {
  const [loading, setLoading] = useState(false)

  const validationSchema = Yup.object({
    title: Yup.string().label('Title').required()
  })

  const formik: any = useFormik({
    initialValues: {
      title: '',
      description: ''
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      setLoading(true)
      brandsService.addBrand(values).then((results: _object) => {
        if (results?.error === false) {
          setLoading(false)
          window.location.reload()
        }
      })
    }
  })

  return (
    <>
      <div
        id="add-home-deal"
        tabIndex={-1}
        aria-hidden="true"
        className="fixed top-0 right-0 left-0 z-50 flex hidden h-[calc(100%-1rem)] max-h-full w-full items-center justify-center overflow-x-hidden overflow-y-auto md:inset-0"
      >
        {/* Background Overlay */}
        <div className="fixed inset-0 bg-black/50"></div>

        {/* Modal Content */}
        <div className="relative z-10 max-h-full w-full max-w-2xl p-4">
          <div className="relative rounded-lg border border-gray-200 bg-white shadow-sm">
            <div className="flex items-center justify-between rounded-t border-b border-gray-200 p-3 px-5">
              <h3 className="text-lg font-semibold">Add New Product</h3>
              <button
                type="button"
                className="ms-auto inline-flex h-8 w-8 items-center justify-center rounded-lg bg-transparent text-sm text-gray-400"
                data-modal-hide="add-home-deal"
              >
                <svg
                  className="h-3 w-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>

            <form className="p-5" onSubmit={formik.handleSubmit}>
              <InputField
                label="Product Title"
                name="title"
                type="text"
                placeholder="Product Title"
                onChange={formik.handleChange}
                value={formik.values.title}
                onBlur={formik.handleBlur}
                required={true}
                error={formik.touched.title && formik.errors.title}
              />
              <div className="mb-4">
                <label
                  htmlFor="description"
                  className="mb-2 flex text-sm leading-none font-medium text-gray-700"
                >
                  Image
                </label>
                <div className="relative flex h-16 w-16 cursor-pointer items-center justify-center rounded-md border-2 border-dashed border-purple-900">
                  <input
                    type="file"
                    className="absolute top-0 right-0 bottom-0 left-0 h-full w-full cursor-pointer opacity-0"
                  />
                  <span className="cursor-pointer text-xl font-bold text-purple-900">+</span>
                </div>
              </div>

              <div className="mt-3">
                <Button
                  label="Add"
                  type="submit"
                  className="rounded-lg bg-purple-900 py-2 text-center text-sm text-white transition hover:bg-purple-950"
                  loading={loading}
                  disabled={!formik.isValid || !formik.dirty}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}
export default AddHomeDeal
